import { render } from "./Resumen.vue?vue&type=template&id=e30437b8&scoped=true"
import script from "./Resumen.vue?vue&type=script&lang=js"
export * from "./Resumen.vue?vue&type=script&lang=js"

import "./Resumen.vue?vue&type=style&index=0&id=e30437b8&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\montalvo.ti\\front-on\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e30437b8"]])

export default __exports__